// The asset page's card (asset-detail-revamp-handover §2): surface, 1 px hairline, 12 px radius, no shadow; card
// titles are h2 under the page's h1.
import { Box, Paper, Stack, Typography } from '@mui/material';
import type { ComponentProps, ReactNode } from 'react';

export function Card({ children, sx, ...rest }: ComponentProps<typeof Paper>) {
  return (
    <Paper
      variant="outlined"
      sx={{ borderRadius: 3, p: { xs: 2, md: 2.5 }, minWidth: 0, ...sx }}
      {...rest}
    >
      {children}
    </Paper>
  );
}

export function CardHeader({ title, aside }: { title: ReactNode; aside?: ReactNode }) {
  return (
    <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 1.5, minHeight: 28 }}>
      <Typography component="h2" variant="subtitle1" sx={{ fontWeight: 600, flex: 1 }}>
        {title}
      </Typography>
      {aside ? <Box>{aside}</Box> : null}
    </Stack>
  );
}
